import { Button, Grid, Typography, TextField, Box, Hidden
    , FormControl, InputLabel, Select, IconButton, Autocomplete } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox, Undo as IconUndo } from "@mui/icons-material";
import api from "../../services/api";
import * as sesionService from "../../services/sesionService";
import * as periodoService from "../../services/periodoService";
import * as catalogoService from "../../services/catalogoService";
import * as personaService from "../../services/personaService";
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { setValue, setListTerapeutas, setListPeriodos, setListEstados } from '../../redux/sessionSearchSlice';
import { setPersonList } from "../../redux/personSlice";
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"
import AutocompleteLista from '../../components/common/AutocompleteLista';
import { useMantenimiento } from "../../hooks/useMantenimiento";

const Index = () => {
    const { isReadOnly } = useMantenimiento("sesion");
    const filters = useSelector((state) => state.sessionSearch.filters);
    const listTerapeutas = useSelector((state) => state.sessionSearch.listTerapeutas);
    const listPeriodos = useSelector((state) => state.sessionSearch.listPeriodos);
    const listEstados = useSelector((state) => state.sessionSearch.listEstados);
    // Desvalidar es una correccion de supervision: la API la pide con
    // "sesion.desvalidar". Sin ese acceso el boton no se muestra, para no
    // dejar a un rol que puede ver la lista con un 403 al pulsarlo.
    const accesos = useSelector((state) => state.seguridad?.accesos) || [];
    const seguridadActiva = useSelector((state) => state.seguridad?.seguridadActiva) || "N";
    const puedeDesvalidar = seguridadActiva !== "S" || accesos.length === 0
        || accesos.includes("sesion.desvalidar");

    const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false)
    const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); }
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);

    // Desvalidar sesiones: el terapeuta no puede, se hace desde aqui.
    const [openDialogValidar, setOpenDialogValidar] = useState(false);

    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();

    const fetchResults = async () => {
        setCargando(true);

        await sesionService.getsSesionResumenView(filters)
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchTerapeutas = async () => {
        const data = await personaService.getsListNaturalPersonByTypeAndName(25, "")
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });

        dispatch(setListTerapeutas(data));
    }
    const fetchPeriodos = async () => {
        await periodoService.getsPeriodoView({
                idTipoTerapia: 0,
                idEstadoApertura: 87,
                mesesHaciaAtras: 0,
                idEstado: 2,
            })
            .then((data) => {
                dispatch(setListPeriodos(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchEstados = async () => {
        await catalogoService.getCatalogosByPadre(1)
            .then((data) => {
                dispatch(setListEstados(data));
                dispatch(setValue({name: "idEstado", value: 2}))
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const annul = async () => {
        await sesionService.annulSesion(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }
    const active = async () => {
        await sesionService.activeSesion(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }
    const desvalidar = async () => {
        await sesionService.desvalidarSesion(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }

    useEffect(() => {
        fetchResults();
        fetchTerapeutas();
        fetchPeriodos();
        fetchEstados();
    }, []);

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'participante', headerName: 'Participante', width: 175, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/session/edit/' + cellValues.row.id + '/' +  + cellValues.row.idTerapiaPeriodo} style={{ color: 'inherit' }}>{cellValues.row.participante}</Link>;
            }
        },
        { field: 'terapeuta', headerName: 'Terapeuta', width: 175, sortable: false, headerAlign: 'center' },
        { field: 'codigoPeriodo', headerName: 'Periodo', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'fecha', headerName: 'Fecha', width: 100, type: 'date'
            , valueFormatter: (value) => moment(value).format('DD/MM/YYYY')
            , sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'estadoValidacion', headerName: 'Validación', width: 100, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'estado', headerName: 'Estado', width: 80, sortable: false, headerAlign: 'center' },
        // Desvalidar: solo desde esta ventana, que es la de supervision.
        { field: 'desvalidar', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                const validado = cellValues.row.idEstadoValidacion === 310;
                if (!validado) return "";
                if (!puedeDesvalidar) return "";

                return <IconButton aria-label="desvalidar" size='small' style={{height: 10}} align={"center"}
                    disabled={isReadOnly} onClick={() => {
                        setSelectId(cellValues.row.id);
                        setOpenDialogValidar(true);
                    }}>
                    <IconUndo />
                </IconButton>;
            }
        },
        { field: 'anular', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                return <IconButton aria-label="anular" size='small' style={{height: 10}} align={"center"} disabled={isReadOnly} onClick={() => {
                    setSelectId(cellValues.row.id);
                    setSelectState(cellValues.row.estado);
                    setOpenDialogAnnulActive(true);
                }}>
                    { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
                </IconButton>;
            }
        },
    ];

    // La carga del autocomplete de terapeutas: con texto busca en el servidor.
    const cargarTerapeutas = useCallback(async (texto) => {
        const response = await api.get(
            `/Persona/GetsListNaturalPersonByTypeAndName?idType=25&name=${encodeURIComponent(texto || "")}`)
            .catch((err) => {
                console.log("Err: ", err);
                return { data: { data: [] } };
            });

        return (response?.data?.data || []).map((row) => ({ id: row.id, descripcion: row.descripcion }));
    }, [])

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Sesiones
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1} padding={0}>
                            <Grid item xs={12} sm={2} >
                                <FormControl fullWidth>
                    {/* La lista de terapeutas crece con cada terapeuta que se registra, asi
                        que el desplegable es un autocomplete: al abrirlo estan los primeros
                        50 (en orden alfabetico) y al escribir se busca en el servidor. */}
                    <AutocompleteLista
                        label="Terapeuta"
                        name="idTerapeuta"
                        value={filters.idTerapeuta || 0}
                        texto={filters.terapeuta || ""}
                        cargar={cargarTerapeutas}
                        onChange={(id, texto) => {
                            dispatch(setValue({name: "idTerapeuta", value: id}))
                            dispatch(setValue({name: "terapeuta", value: texto}))
                        }}
                        size="small"
                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <TextField
                                    name="participante"
                                    label="Participante"
                                    value={filters.participante}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "participante", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-periodo" shrink>Periodo</InputLabel>
                                    <Select
                                        native
                                        label="Periodo"
                                        value={filters.idPeriodo}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idPeriodo", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idPeriodo',
                                            id: 'input-periodo',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listPeriodos.map((row) => (
                                            <option key={row.id} value={row.id}>{row.codigo}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={4} md={3} lg={2}>
                                <TextField
                                    required
                                    name="fechaInicio"
                                    label="Inicio"
                                    fullWidth
                                    type="date"
                                    value={moment(filters.fechaInicio).format('yyyy-MM-DD')}
                                    onChange={(event) => {
                                        dispatch(setValue({name: "fechaInicio", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={6} sm={4} md={3} lg={2}>
                                <TextField
                                    required
                                    name="fechaFin"
                                    label="Fin"
                                    fullWidth
                                    type="date"
                                    value={moment(filters.fechaFin).format('yyyy-MM-DD')}
                                    onChange={(event) => {
                                        dispatch(setValue({name: "fechaFin", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estado" shrink>Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.idEstado}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idEstado", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idEstado',
                                            id: 'input-estado',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstados.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" size="medium" fullWidth onClick={() => {
                                    fetchResults()
                                }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                disabled={isReadOnly}
                                // hideNewButton={false}
                            />
                        </Box>
                    </Grid>
                    <DialogYesNo open={openDialogAnnulActive} openClose={openCloseDialogAnnulActive} setYes={ selectState == "A" ? annul : active} 
                        setNo={() => { return }}
                        titulo={(selectState == "A" ? "Anular" : "Activar") + " Sesion"}
                        texto={"Esta seguro de " + (selectState == "A" ? "anular" : "activar") + " la sesion?"} >
                    </DialogYesNo>
                    <DialogYesNo open={openDialogValidar} openClose={() => setOpenDialogValidar(!openDialogValidar)} setYes={desvalidar}
                        setNo={() => { return }}
                        titulo={"Desvalidar Sesion"}
                        texto={"Esta seguro de desvalidar la sesion? Volvera a No Validado y se podra modificar."} >
                    </DialogYesNo>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index
